/**
 * Partners — mapping centralisé slug → display name.
 * Utilisé par toutes les modales d'achat, favoris, wardrobe.
 *
 * Le backend (handleScrapeUrlRequest dans handler.js) retourne un slug court
 * dans product.partner. Cette table le convertit en nom affichable.
 */

export const PARTNER_NAMES = {
  // Luxe
  chanel: 'Chanel',
  dior: 'Dior',
  louisvuitton: 'Louis Vuitton',
  hermes: 'Hermès',
  gucci: 'Gucci',
  prada: 'Prada',
  ysl: 'Saint Laurent',
  balenciaga: 'Balenciaga',
  celine: 'Celine',
  givenchy: 'Givenchy',
  fendi: 'Fendi',
  burberry: 'Burberry',
  valentino: 'Valentino',
  versace: 'Versace',
  armani: 'Armani',
  dolcegabbana: 'Dolce & Gabbana',
  bottegaveneta: 'Bottega Veneta',
  loewe: 'Loewe',
  miumiu: 'Miu Miu',
  jacquemus: 'Jacquemus',
  isabelmarant: 'Isabel Marant',
  chloe: 'Chloé',

  // Premium FR
  sandro: 'Sandro',
  maje: 'Maje',
  claudiepierlot: 'Claudie Pierlot',
  thekooples: 'The Kooples',
  bash: 'Ba&sh',
  sezane: 'Sézane',
  ami: 'AMI Paris',

  // Sport / Sneakers
  nike: 'Nike',
  adidas: 'Adidas',
  puma: 'Puma',
  newbalance: 'New Balance',
  reebok: 'Reebok',
  lacoste: 'Lacoste',
  veja: 'Veja',
  converse: 'Converse',
  vans: 'Vans',
  decathlon: 'Decathlon',
  jdsports: 'JD Sports',
  courir: 'Courir',
  footlocker: 'Foot Locker',
  intersport: 'Intersport',
  gosport: 'Go Sport',

  // Fast-fashion
  zara: 'Zara',
  zalando: 'Zalando',
  hm: 'H&M',
  asos: 'ASOS',
  mango: 'Mango',
  uniqlo: 'Uniqlo',
  andotherstories: '& Other Stories',
  cos: 'COS',
  arket: 'Arket',
  weekday: 'Weekday',
  monki: 'Monki',
  bershka: 'Bershka',
  pullandbear: 'Pull & Bear',
  stradivarius: 'Stradivarius',
  massimodutti: 'Massimo Dutti',

  // Grands magasins / marketplaces
  laredoute: 'La Redoute',
  galerieslafayette: 'Galeries Lafayette',
  printemps: 'Printemps',
  monoprix: 'Monoprix',
  spartoo: 'Spartoo',
  sarenza: 'Sarenza',
  matchesfashion: 'Matches Fashion',
  farfetch: 'Farfetch',
  mytheresa: 'Mytheresa',
  netaporter: 'Net-a-Porter',
  ssense: 'SSENSE',
  vestiairecollective: 'Vestiaire Collective',

  // Enseignes grand public FR
  promod: 'Promod',
  kiabi: 'Kiabi',
  etam: 'Etam',
  camaieu: 'Camaïeu',
  pimkie: 'Pimkie',
  jennyfer: 'Jennyfer',
  celio: 'Celio',
  brice: 'Brice',
  devred: 'Devred',
  jules: 'Jules',

  // Lingerie
  darjeeling: 'Darjeeling',
  princessetamtam: 'Princesse Tam Tam',
  chantelle: 'Chantelle',
  victoriassecret: "Victoria's Secret",

  // Autres
  iqueens: 'iQueens',
  cashmere: 'Cashmere Boutique',
  amazon: 'Amazon',
  ebay: 'eBay',
  vinted: 'Vinted',
  other: 'Partenaire',
};

/**
 * Retourne le nom d'affichage pour un slug de partenaire.
 * Fallback : capitalize le slug si inconnu (ex "monsiteperso" → "Monsiteperso").
 */
export function getPartnerName(slug) {
  if (!slug) return 'Partenaire';
  const s = String(slug).toLowerCase().trim();
  if (PARTNER_NAMES[s]) return PARTNER_NAMES[s];
  // Fallback : première lettre en majuscule
  return s.charAt(0).toUpperCase() + s.slice(1);
}
